import { HTTP } from '../http-commons'

export default class Company {

  async get (url) {
    return await HTTP.get(url)
  }
}
